<template>
    <div>
        <Nav />
        <transition name="fade">
            <div class="container mt-4 content">
                <router-view>
                </router-view>
            </div>
        </transition>
    </div>
</template>

<script>
import Nav from '@/components/partials/Nav.vue';

    export default {
        name:"AppLayout",
        components:{
            Nav
        }
    }
</script>